module.exports = __webpack_public_path__ + "media/naphal_m.b2293e6a.mp3";